/**
 * services/web-ui/src/hooks/useCallList.ts
 *
 * W4-C: TanStack Query hook for the voice session list.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchSessions, type SessionListItem } from "../api/voice-sessions-list";

export interface CallListFilters {
  status?: string;
  limit?: number;
  offset?: number;
}

export interface UseCallListResult {
  sessions: SessionListItem[];
  total: number;
  isLoading: boolean;
  error: Error | null;
}

export function useCallList(filters: CallListFilters = {}): UseCallListResult {
  const { limit = 50, offset = 0, status } = filters;

  const { data, isLoading, error } = useQuery({
    queryKey: ["voice", "sessions", { limit, offset, status }],
    queryFn: () => fetchSessions({ limit, offset, status }),
    staleTime: 15_000,
    refetchInterval: 30_000,
  });

  return {
    sessions: data?.sessions ?? [],
    total: data?.total ?? 0,
    isLoading,
    error: error as Error | null,
  };
}
